import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Error } from 'wix-style-react/dist/src/Icons'
import { HELVETICA } from 'components/styles'

const Container = styled.div`
  box-sizing: border-box;
  display: block;
  position: relative;
  padding: 2px 0;
  margin: 2px 0;
  vertical-align: middle;
`
const focusedInput = css`
  box-shadow: inset 0 -2px 0 #3899EC;
`
const idleInput = css`
  box-shadow: inset 0 -1px 0 #E1E7EA;
`
const invalidInput = css`
  box-shadow: inset 0 -2px 0 #F2564D;
`

const matchInputState = (focused, valid) => {
  if (focused) {
    return focusedInput
  } else {
    return valid ? idleInput : invalidInput
  }
}

const Input = styled.input`
  ${HELVETICA};
  box-sizing: border-box;
  display: block;
  padding: 0;
  border: none;
  appearance: none;
  border-radius: 0;
  outline-width: 0;
  line-height: 22px;
  font-size: 15px;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  padding-left: 3px;
  padding-bottom: 3px;
  width: 236px;
  ${props => matchInputState(props.focused, props.valid)}
`

const focusedLabel = css`
  transform: translate3d(-1px, -1.25em, 0) scale3d(0.75, 0.75, 1);
`

const Label = styled.label`
  ${HELVETICA};
  box-sizing: border-box;
  display: block;
  position: absolute;
  left: 4px;
  top: 1px;
  text-align: left;
  padding: 0;
  pointer-events: none;
  height: 20px;
  right: auto;
  bottom: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  max-width: 100%;
  transform-origin: 0 0;
  transition: transform 0.2s 0.15s, color 0.5s;
  transition-timing-function: ease-out;
  color: ${props => {
    if (props.focused) {
      return '#333'
    } else {
      return props.valid ? '#333' : '#F2564D'
    }
  }};
  font-size: 15px;
  ${props => (props.focused || !props.valid) ? focusedLabel : null}
`
const ErrorIcon = styled.span`
  position: absolute;
  color: #F2564D;
  font-size: 16px;
  right: 2px;
  top: 0px;
`

class FancyInput extends Component {

  constructor () {
    super()
    this.state = { focused: false, valid: true }
  }

  setupValidState = (s) => {
    this.setState({
      focused: false,
      valid: s.valid,
      invalidMessage: s.invalidMessage,
    })
  }

  onFocus = () => {
    this.setState({ focused: true })
  }

  value () {
    return this.textInput.value
  }

  setValue (v) {
    this.textInput.value = v
    this.onBlur()
  }

  onBlur = () => {
    const value = this.textInput.value
    const validate = this.props.onBlurValidation

    if (validate && !validate(value) && (value !== '')) {
      this.setState({
        focused: false,
        valid: false,
        invalidMessage: this.props.onBlurValidationMessage,
      })
    } else {
      this.setState({
        focused: !(value === ''),
        valid: true,
        invalidMessage: '',
      })
    }
  }

  render () {
    return <Container>
      <Input
        type={this.props.type || 'text'}
        focused={this.state.focused}
        valid={this.state.valid}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        innerRef={(input) => { this.textInput = input }}
      />
      <Label focused={this.state.focused} valid={this.state.valid}>
        {this.state.focused || this.state.valid
          ? this.props.placeholder
          : this.state.invalidMessage}
      </Label>
      {!this.state.valid && !this.state.focused
        ? <ErrorIcon><Error size='1.4em' /></ErrorIcon>
        : null}
    </Container>
  }
}

FancyInput.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  onBlurValidation: PropTypes.func,
  onBlurValidationMessage: PropTypes.string,
}

export default FancyInput



// WEBPACK FOOTER //
// ./src/components/signin/FancyInput.js